import { defineStore } from "pinia";

export interface SidebarSection {
  id: string;
  label: string;
  icon: string;
}

export const useSidebarStore = defineStore("sidebar", () => {
  const sections = ref<SidebarSection[]>([]);

  return { sections };
});
